// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3aXUK","loaderOuter":"PageOverlayLoader_loaderOuter__3xJtc"};